module.exports = __webpack_public_path__ + "static/media/chevron-right.01c92387.svg";